import React, { Component } from 'react';
import {Row,Col} from 'react-bootstrap';

import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
// import { format } from 'date-fns';

import { MSG_DYNAMIC_FIELD_REQUIRED, MSG_REQUIRED } from '../../configs/msgConfigs'; 
import { LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP, LOGIN_CREW_GROUP, STR_VEHICLE_INFO } from '../../configs/staticConfigs'; 
import {LBL_SAVE} from '../../configs/labelConfigs'; 

class DynamicFieldsDetails extends Component {

    constructor(props){
        super();

        this.state = {   
            dynamicFieldsFor: 0,
            userGroup: 0,  
            userProfileId: '',
            dynFieldsActiveItem: { id: 0, name: '', field_details: [], user_type: 0, show_tab: true, icon_name: '' },    
            activePageId: 0,     
            deleteRowIndexNum: 0,                 
            formErrors: [],
            formClick : false,
            dateFormat: 'dd/MM/yyyy',
            dynamicFieldsSavedData: [],
        } 
        this.onHandleChange = this.onHandleChange.bind(this); 
        this.checkFormData  = this.checkFormData.bind(this); 
        this.saveFormData  = this.saveFormData.bind(this); 
    }

    onHandleChange = (e, item) =>{
        // field_details :[{"value":"","field_id":15,"field_name":"Bank Name","field_type":"string","is_mandatory":true}]
        // const valStr = e.target.type === "checkbox" ? e.target.checked : e.target.value;  
        
        let valStr          = ''; // e.target.value;  
        let newFieldDetails = []; 
        let dynFieldsActiveItem = this.state.dynFieldsActiveItem; 
       
        if(item.field_type==='string') { 
            valStr          = e.target.value;  
            if(item.is_mandatory && valStr.trim()==='') item.errMsg = MSG_DYNAMIC_FIELD_REQUIRED; 
            else item.errMsg = ''; 
            item.value = valStr; 
            newFieldDetails = this.state.dynFieldsActiveItem.field_details.map((obj, index) => {
                return item.field_id === obj.field_id ? item : obj; 
            });
            this.setState({formClick:true, dynFieldsActiveItem: { ...dynFieldsActiveItem, field_details:newFieldDetails}});  
        }
        else if(item.field_type==='date') { 
            valStr = e;  
            if(item.is_mandatory && (valStr==='' || valStr===null)) item.errMsg = MSG_DYNAMIC_FIELD_REQUIRED; 
            else item.errMsg = ''; //format(new Date(date), 'yyyy-MM-dd');
            item.value = valStr;  
            newFieldDetails = this.state.dynFieldsActiveItem.field_details.map((obj, index) => {
                return item.field_id === obj.field_id ? item : obj; 
            });
            this.setState({formClick:true, dynFieldsActiveItem: { ...dynFieldsActiveItem, field_details:newFieldDetails}});  
        } 
    }

    onApproveChange = (e) =>{
        let val = e.target.checked;
        let dynFieldsActiveItem = this.state.dynFieldsActiveItem;
        dynFieldsActiveItem.approved = val;
        this.setState({dynFieldsActiveItem:dynFieldsActiveItem});

    }  

    checkFormData() {
        let foundError = 0; 
        let newFieldDetails = []; 
        let dynFieldsActiveItem = this.state.dynFieldsActiveItem;
        newFieldDetails = this.state.dynFieldsActiveItem.field_details.map((item, index) => {
            if(item.is_mandatory && (item.value==='' || item.value===null)) {   
                foundError = 1; 
                item.errMsg = MSG_DYNAMIC_FIELD_REQUIRED; 
            } 
            return item; 
        });
        this.setState({dynFieldsActiveItem: { ...dynFieldsActiveItem, field_details:newFieldDetails}});  
        if(foundError===0) {
            return true; 
        }
     }

     saveFormData = (e)=>{
        e.preventDefault(); 
        this.setState({formClick:true});
        if(this.checkFormData()) {             
     
            // REMOVE errMSG from FIELD DATA 
            let approved = false;
            if(this.state.dynFieldsActiveItem.approved){
                approved = this.state.dynFieldsActiveItem.approved;
            }
            let newFieldDetails = []; 
            let fields = this.state.dynFieldsActiveItem.field_details; 
            // APPROVED IS NOT SAVING IF WE ADD IT OUTSIDE FIELD DETAILS, SO INCLUDING THE SAME VALUE TO ALL FIELD DETAILS OBJECT, SO TO RETRIEVE JUST TAKE VALUE OF approved FROM THE FIRST FIELD DETAILS ELEMENT  - 14Sep22
            fields.forEach((item) => {
                if(STR_VEHICLE_INFO.toLowerCase()===this.state.dynFieldsActiveItem.name.trim().toLowerCase()) {
                    newFieldDetails.push({field_id:item.field_id, field_name:item.field_name, field_type:item.field_type, is_mandatory:item.is_mandatory, value:item.value, approved:approved});
                }
                else {
                    newFieldDetails.push({field_id:item.field_id, field_name:item.field_name, field_type:item.field_type, is_mandatory:item.is_mandatory, value:item.value});
                }
            });
            
            let newObj = {}

            if(this.state.dynamicFieldsFor===LOGIN_CLIENT_GROUP || this.state.dynamicFieldsFor===LOGIN_CREW_GROUP) {
                newObj = {approved:approved, user_type_id:parseInt(this.state.dynamicFieldsFor,10), dynamic_field_id:this.state.dynFieldsActiveItem.id, field_value_id:this.state.dynFieldsActiveItem.field_value_id, name:this.state.dynFieldsActiveItem.name,  field_details:newFieldDetails, vehicle_master_id:this.state.dynFieldsActiveItem.vehicle_master_id};
            }
            else {
                // newObj = { approved:approved, dynamic_field_id:this.state.dynFieldsActiveItem.master_id, field_value_id:this.state.dynFieldsActiveItem.field_value_id, name:this.state.dynFieldsActiveItem.name,  field_details:newFieldDetails, vehicle_master_id: this.state.dynFieldsActiveItem.vehicle_master_id};
                newObj = { dynamic_field_id:this.state.dynFieldsActiveItem?.master_id ? this.state.dynFieldsActiveItem.master_id : this.state.dynFieldsActiveItem.id, field_value_id:this.state.dynFieldsActiveItem.field_value_id, name:this.state.dynFieldsActiveItem.name,  field_details:newFieldDetails, vehicle_master_id: this.state.dynFieldsActiveItem.vehicle_master_id}; 
            }
              

            let saveDataObj = {}; 
            if(this.state.dynamicFieldsFor===LOGIN_AFFILIATE_GROUP) {
                saveDataObj = {userProfileId: this.state.userProfileId, reqFor:LOGIN_AFFILIATE_GROUP, ...newObj}; 
                this.props.dynamicFieldsDataSaveAction(saveDataObj);  
            }
            else if(this.state.dynamicFieldsFor===LOGIN_CLIENT_GROUP || this.state.dynamicFieldsFor===LOGIN_CREW_GROUP) {
                saveDataObj = {userProfileId: this.state.userProfileId, reqFor:LOGIN_CLIENT_GROUP, ...newObj}; 
                this.props.dynamicFieldsDataSaveAction(saveDataObj);  
            }
        }
    }

    componentDidMount() { 
        let newArray = []; 
        let tmpObj = {}; 
        let dataObj = []; 
        let newVal = ''; 
        let idVal = '';  
        
        // console.log('this.props.dynamicFieldsSavedData: '+JSON.stringify(this.props.dynamicFieldsSavedData)); 
        // CHECK SAVED DATA AND LOAD IT TO THE FIELDS 
        console.log(this.props.dynamicFieldsSavedData);
        if(this.props.dynamicFieldsSavedData){
            let res = this.props.dynamicFieldsSavedData.filter(it => it ? it.name.toLowerCase().trim().includes(this.props.dynFieldsActiveItem.name.toLowerCase().trim()):false); 
            if(Array.isArray(res) && (res[0])) { 
                dataObj = res[0].field_details; 
                idVal = res[0].id; 
            }
        }

        newArray = this.props.dynFieldsActiveItem.field_details.map((item,index) => {   
            newVal = ''; 
            if(Array.isArray(dataObj)) { 
                dataObj.forEach((dataItem) => {
                    if((item.field_id===dataItem.field_id)) { 
                        newVal = dataItem.value; 
                    }
                });  
            }
            return(tmpObj = { ...item, value:newVal, errMsg: item.is_mandatory ? '' : '' }); 
        })
        tmpObj = { ...this.props.dynFieldsActiveItem, field_value_id:idVal, field_details:newArray }; 
        let pId = 0;
        if(this.props.hasOwnProperty('profileId') && this.props.profileId > 0)  pId = this.props.profileId;
        else if(this.props.hasOwnProperty('clientId') && this.props.clientId > 0)  pId = this.props.clientId;  
        else if(this.props.hasOwnProperty('crewId') && this.props.crewId > 0)  pId = this.props.crewId;  
        this.setState({userGroup:this.props.userGroup, userProfileId:pId, dynFieldsActiveItem:tmpObj, dynamicFieldsFor:this.props.dynamicFieldsFor}); 
    }

    componentDidUpdate() {
        // IF SAVED DATA DETAILS ARE PASSED, LOAD IT INTO STATE VARIABLES 
        if(this.state.dynamicFieldsSavedData.length===0 && this.props.dynamicFieldsSavedData.length > 0){
            let newArray = []; 
            let tmpObj = {}; 
            let dataObj = []; 
            let newVal = ''; 
            let idVal = '';  
            let approved = false;  
            let vehicle_master_id = '';  
            let res = this.props.dynamicFieldsSavedData.filter(it => it ? it.name.toLowerCase().trim().includes(this.props.dynFieldsActiveItem.name.toLowerCase().trim()):false); 
            if(Array.isArray(res) && (res[0])) { 
                dataObj = res[0].field_details; 
                idVal = res[0].id; 
                // APPROVED DATA IS ADDED TO EACH field_details OBJECT REPEATEDLY AS IT IS NOT SAVING APPROVED STATUS IF WE GIVE IT AS AN INDEPENDANT VALUE, SO JUST TAKE THE APPROVED STATUS FROM THE FIRST field_details OBJECT 
                // if(res[0].approved){
                //     approved = res[0].approved
                // }
                if(dataObj[0]?.approved){
                    approved = dataObj[0].approved
                }
                if(res[0].vehicle_master_id){
                    vehicle_master_id = res[0].vehicle_master_id
                }
            }

            newArray = this.props.dynFieldsActiveItem.field_details.map((item,index) => {   
                newVal = ''; 
                if(Array.isArray(dataObj)) { 
                    dataObj.forEach((dataItem) => {
                        if((item.field_id===dataItem.field_id)) { 
                            newVal = dataItem.value; 
                        }
                    });  
                }
                return(tmpObj = { ...item, value:newVal, errMsg:'' }); 
            })

            tmpObj = { ...this.props.dynFieldsActiveItem, field_value_id:idVal, field_details:newArray, approved:approved, vehicle_master_id:vehicle_master_id }; 
            let pId = 0;
            if(this.props.hasOwnProperty('profileId') && this.props.profileId > 0)  pId = this.props.profileId;
            else if(this.props.hasOwnProperty('clientId') && this.props.clientId > 0)  pId = this.props.clientId;  
            else if(this.props.hasOwnProperty('crewId') && this.props.crewId > 0)  pId = this.props.crewId;  
            
            this.setState({userGroup:this.props.userGroup, userProfileId:pId, dynFieldsActiveItem:tmpObj, dynamicFieldsFor:this.props.dynamicFieldsFor, dynamicFieldsSavedData:this.props.dynamicFieldsSavedData});
            // console.log('componentDidUpdate: '+JSON.stringify(this.props.dynamicFieldsSavedData)); 
        }
    }

    render(){
        let fieldId = '';
        let dtVal = ''; 
        // const { affiliateData} = this.props; 
        let companyName = ''; 
        if(this.props.hasOwnProperty('showNameInHeader')) companyName = this.props.showNameInHeader; 
        let isSuperAdmin = this.props.isSuperAdmin ? this.props.isSuperAdmin : false; 
        return(
            <div className="form-group col-md-12">
                <div className="box  margin-top-12">

                    {/* <div className="tab-head tdVeticalMiddle">
                        {this.props.noHeaderName && this.props.noHeaderName==="yes" && <h6>&nbsp;</h6>}
                        {!this.props.noHeaderName && <h6>{this.props.headerText} {(companyName) && <span>{' - '+companyName}</span>}</h6>}
                    </div> */}

                    {!this.props.noHeaderName && <div className="tab-head tdVeticalMiddle">
                        <h6>{this.props.headerText} {(companyName) && <span>{' - '+companyName}</span>}</h6>
                    </div>}

                    <div className="box-content">
                        {/* {"value":"","field_id":1587962613155,"field_name":"Bank Name","field_type":"string","is_mandatory":true} */}
                        <Row>
                        {this.state.dynFieldsActiveItem.field_details.map((item,index) => {  
                            fieldId = item.field_id; 
                            
                            if(item.value==='' || item.value===null) {
                                dtVal = ''; // new Date(); 
                            }
                            else {
                                dtVal = new Date(item.value); 
                            }
                            return(
                                <Col md={6} key={index} className={item.field_type==='date'?'margin-bottom-20':''}>
                                    <div className="form-group">
                                        <label>{item.field_name}</label>
                                        <div className="input-input">
                                        {/* onChange={selected => this.props.onDateChange(selected)}  this.state.dynFieldsActiveItem.field_details[index]  */}
                                            <React.Fragment> 
                                                
                                                { (item.field_type==='string') && 
                                                    <input type="text" name={"txt_fieldValue_"+fieldId} value={item.value} onChange={(e) => this.onHandleChange(e,item)}  className={item.errMsg!=='' ? "input-error" : ''}/>
                                                }

                                                {/* selected={selectedDob} 
                                                    onChange={selected => this.props.onDateChange(selected)}  */}
                                                { (item.field_type==='date') && 
                                                    <DatePicker 
                                                        selected={dtVal}
                                                        onChange={dateVal => this.onHandleChange(dateVal,item)}
                                                        
                                                        placeholderText="Select a Date"
                                                        className={item.errMsg!=='' ? "input-error" : ''} 
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        fixedHeight   
                                                        autoComplete="off"
                                                        dateFormat={this.state.dateFormat}
                                                    /> 
                                                }
                                                {/* {item.is_mandatory && (item.errMsg!=='') && (
                                                <div className="text-red left-align text-12">{MSG_DYNAMIC_FIELD_REQUIRED}</div>
                                                )}  */}
                                            </React.Fragment>
                                            
                                        </div>
                                    </div>
                                </Col>)
                        } ) }
                        </Row>
                        <div className="clearfix">
                            {!isSuperAdmin && <> </>}
                                <button className="btn btn-primary float-right" onClick={this.saveFormData} >{LBL_SAVE}</button>
                                {this.state.dynFieldsActiveItem.name === 'Vehicle Info' && <div className="custom-checkbox float-left approve-chk" > 
                                        <input type="checkbox" id="approve" name="approve"  checked={this.state.dynFieldsActiveItem.approved} value={this.state.dynFieldsActiveItem.approved} onChange={e => this.onApproveChange(e)} />
                                        <label className="checkbox" htmlFor="approve" ></label>
                                        <label htmlFor="approve" > &nbsp; Approve</label> 
                                    
                                </div>}
                            
                        </div>
                        <div className="clearfix">&nbsp; </div>
                        <div className="clearfix">&nbsp; </div>
                        <div className="clearfix">&nbsp; </div>
                        <div className="clearfix">&nbsp; </div>
                        <div className="clearfix">&nbsp; </div>
                        <div className="clearfix">&nbsp; </div>
                    </div>
                </div>
                <div className="clearfix">&nbsp; </div>
                <div className="clearfix">&nbsp; </div>
                <div className="clearfix">&nbsp; </div>
            </div>
            
        )
    }

}
export default DynamicFieldsDetails;